export default __webpack_public_path__ + "static/media/Campion.3eb9f85a.jpg";